import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  userName: string | null;
}

const getInitialAuth = (): AuthState => {
  const token = localStorage.getItem('public_private_token') || sessionStorage.getItem('public_private_token');
  const storedUser = localStorage.getItem('monetile_user');
  let userName = null;
  if (storedUser) {
    try {
      const u = JSON.parse(storedUser);
      userName = u.name || u.firstName || u.email;
    } catch (e) {}
  }
  const valid = Boolean(token && token !== 'null' && token !== 'undefined' && token !== 'false');
  return {
    isAuthenticated: valid,
    token: valid ? token : null,
    userName: valid ? userName : null,
  };
};

const initialState: AuthState = getInitialAuth();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (
      state,
      action: PayloadAction<{ token: string; userName: string }>
    ) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.userName = action.payload.userName;
      localStorage.setItem('public_private_token', action.payload.token);
      sessionStorage.setItem('public_private_token', action.payload.token);
      const domain = window.location.hostname.includes("sourceseas.com") ? ".sourceseas.com" : window.location.hostname;
      document.cookie = `public_private_token=${action.payload.token}; path=/; domain=${domain}; max-age=2592000; SameSite=Lax`;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.userName = null;
      localStorage.removeItem('public_private_token');
      localStorage.removeItem('monetile_user');
      sessionStorage.removeItem('public_private_token');
      const domain = window.location.hostname.includes("sourceseas.com") ? ".sourceseas.com" : window.location.hostname;
      document.cookie = `public_private_token=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;

export default authSlice.reducer;
